import React from 'react';
import { Table } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loading } from '@rd-web-markets/shared/dist/util';
const RecentCompanies = _ref => {
  let {
    companies,
    recentCompanyIds
  } = _ref;
  const location = useLocation();
  const {
    t
  } = useTranslation();
  const columns = [{
    text: ''
  }];
  if (!companies) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }
  const rows = recentCompanyIds ? recentCompanyIds.map(id => {
    const company = companies.find(company => String(company.id) === id);
    if (company) {
      return {
        companyData: [company.name, `${location.pathname}/companies/${company.id}/master`]
      };
    }
  }).filter(row => row) : [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, !recentCompanyIds ? /*#__PURE__*/React.createElement("p", {
    className: "text-center text-secondary"
  }, t('no_recent_companies')) : /*#__PURE__*/React.createElement(Table, {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, columns.map((column, index) => {
    return /*#__PURE__*/React.createElement("th", {
      className: "text-center",
      key: index
    }, column.text);
  }))), /*#__PURE__*/React.createElement("tbody", null, rows.map((row, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: index
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: row.companyData[1]
    }, row.companyData[0])));
  }))));
};
export default RecentCompanies;